module.exports = __webpack_public_path__ + "img/slide-last-warning.9a46100c.png";